var angular = require('angular');
var _module = angular.module('benoit');

require('../../services/lr-touch');
require('../../services/mortgage-calculator-store');
require('../../filters');

_module.controller('PriceSliderCtrl', [
    '$log',
    '$scope',
    '$element',
    '$attrs',
    '$mortgageCalculatorStore',

    function PriceSliderCtrl($log, $scope, $element, $attrs, $mortgageCalculatorStore) {
        $log.debug('PriceSliderCtrl', this);

        var vm = this;
        vm.model = {
            showMonthlyPayment: false,
            percent: undefined,
            handleStartPercent: undefined,
            sliderOptions: {
                floor: parseInt(vm.min),
                ceil: parseInt(vm.max)
            },
            maxAny: false,
            price: undefined
        };
        vm.model.percent = getPercent();
        vm.model.handleStartPercent = getPercent();
        vm.events = {
            onDrag: onDrag
        };
        vm.services = {
            calculateMonthlyPayment: calculateMonthlyPayment
        };
        vm.model.price = vm.ngModel = vm.ngModel || parseInt(vm.max || 2000000) / 2;

        // $watch
        $scope.$watch(function () { return $mortgageCalculatorStore.loading; }, function (value) {
            if(!value && $mortgageCalculatorStore.interest_rates['30']) {
                vm.model.showMonthlyPayment = true;
            }
        });

        $scope.$watch(function () { return vm.ngModel; }, function (value) {
            if(value == null && !vm.model.maxAny) {
                vm.model.price = vm.max;
            } else {
                vm.model.price = value;
            }
        });

        $scope.$watch(function () { return vm.ngRequired; }, function (value) {
            if(value === false || (value === undefined && !$attrs.hasOwnProperty('ngRequired'))) {
                vm.model.maxAny = true;
            } else {
                vm.model.maxAny = false;
            }
        });

        // Functions
        function getPercent() {
            return Math.round(vm.ngModel / parseInt(vm.max) * 100);
        }

        function onDrag(e) {
            var value = Math.round(e.percentX * 100) / 100 * parseInt(vm.max);

            if(value !== vm.model.price) {
                vm.model.percent = e.percentX * 100;
                vm.model.price = value;
                vm.ngModel = vm.model.price === vm.max && vm.model.maxAny ? null : vm.model.price;
            }
        }

        function calculateMonthlyPayment() {
            var principal = vm.model.price * 0.8;
            var interest = $mortgageCalculatorStore.interest_rates['30'];
            var numPayments = 30 * 12;

            return $mortgageCalculatorStore.calculatePrincipalAndInterestPayment(principal, interest, numPayments);
        }
    }
]);

_module.component('priceSlider', {
    template: require('./index.html'),
    controllerAs: 'vm',
    controller: 'PriceSliderCtrl',
    bindings: {
        min: '<',
        max: '<',
        ngModel: '=?',
        ngRequired: '=?'
    }
});
